import { xs_languageCode } from '../..';
import { getAggregationAndBetFromBetId } from './getAggregationAndBetFromBetId';
import { getAggregationAndBetFromBetIdAndSportId } from './getAggregationAndBetFromBetIdAndSportId';
import { getOccurrenceOfMarket } from './getOccurrenceOfMarket';
import { parseHandicap } from './parseHandicap';
import { getGenericHandicapDescriptionPart } from './getGenericHandicapDescriptionPart';

export function getBetDescription(bet, genericReplace, sportId, otherBetsArray) {
    //const desc = bet.desc != null ? bet.desc: '';
   	const occurrenceOfThisMarket = otherBetsArray? getOccurrenceOfMarket(bet.cs || bet.id, otherBetsArray): null;
   	let desc = bet.desc || bet.rds;
   	if(!desc) {
   		desc = "";
   	}
	let parametrica = bet.parametrica;
	let calculateHandicapDescription = bet.calculateHandicapDescription;
	let tipoHandicap = bet.tipoHandicap;
	const betId = bet.cs || bet.id;
	const handicap = bet.h || bet.handicap;
	let genericDescription = null;
	let specificLineAggregate = false; // se la linea aggregata è specifica di una scommessa con handicap, allora se è genericReplace (header scommesse) calcolo direttamente l'handicap. Se il trader ha specificato la descrizione specifica, allora calculateHandicapDescription sarà false
    const aggregateContainer = sportId? 
    getAggregationAndBetFromBetIdAndSportId(sportId, betId, handicap) :
    getAggregationAndBetFromBetId(betId, handicap);
    // getting the native description of this market
    if (aggregateContainer && aggregateContainer.market) {
    	tipoHandicap = aggregateContainer.market.tipoHandicap;
		desc = aggregateContainer.market.desc;
		genericDescription = aggregateContainer.market.genericDescription;
		parametrica = aggregateContainer.market.parametrica;
		specificLineAggregate = aggregateContainer.market.handicap != 0;
		calculateHandicapDescription = aggregateContainer.market.calculateHandicapDescription;
		if (aggregateContainer.aggregation?.compattate) {
			for (let descComp in aggregateContainer.aggregation.compattate) {
				const compactedBets = aggregateContainer.aggregation.compattate[descComp];
				for (let kc in compactedBets) {
					if (compactedBets[kc] === (bet.cs + "_" + bet.h)) {
						desc = descComp;
						if (aggregateContainer.aggregation.localeCmpDesc && 
                            aggregateContainer.aggregation.localeCmpDesc[descComp] && 
                            aggregateContainer.aggregation.localeCmpDesc[descComp][xs_languageCode] != null) {
                            desc =  aggregateContainer.aggregation.localeCmpDesc[descComp][xs_languageCode];
						}
					}
				}
			}
		}
    }
    const itIsTheOnlyHandicapLineForThisEvent = occurrenceOfThisMarket && occurrenceOfThisMarket == 1;
    const containsHandicapPlaceholder = desc.indexOf("@@H") >= 0 || desc.indexOf("{{H") >= 0;
    const uselessHandicapParsing = itIsTheOnlyHandicapLineForThisEvent && !containsHandicapPlaceholder;
    // l'handicap viene calcolato se:
    // 1 - la scommessa e' parametrica (calculateHandicapDescription è true) e genericReplace è false
    // 2 - la scommessa e' una linea specifica generata da una parametrica e gli manca la customizzazione sulla scommesse_lang (calculateHandicapDescription true) e genericReplace è false
    // 2 - la scommessa è una linea specifica senza customizzazione (calculateHandicapDescription true), genericReplace è true, e la linea specifica è l'unica presente nell'aggregata 
    if (calculateHandicapDescription && genericReplace && !specificLineAggregate) {	
       desc = genericDescription ||
       		   desc.replaceAll('@@H1@@', getGenericHandicapDescriptionPart(betId, handicap, 1))
                   .replaceAll('@@H2@@', getGenericHandicapDescriptionPart(betId, handicap, 2))
                   .replaceAll('@@H3@@', getGenericHandicapDescriptionPart(betId, handicap, 3))
                   .replaceAll('@@H4@@', getGenericHandicapDescriptionPart(betId, handicap, 4))
                   .replaceAll('@@H5@@', getGenericHandicapDescriptionPart(betId, handicap, 5))
                   .replaceAll('@@H6@@', getGenericHandicapDescriptionPart(betId, handicap, 6))
                   .replaceAll('@@H7@@', getGenericHandicapDescriptionPart(betId, handicap, 7))
                   .replaceAll('@@H8@@', getGenericHandicapDescriptionPart(betId, handicap, 8))
                   .replaceAll('{{H1}}', getGenericHandicapDescriptionPart(betId, handicap, 1))
                   .replaceAll('{{H2}}', getGenericHandicapDescriptionPart(betId, handicap, 2))
                   .replaceAll('{{H3}}', getGenericHandicapDescriptionPart(betId, handicap, 3))
                   .replaceAll('{{H4}}', getGenericHandicapDescriptionPart(betId, handicap, 4))
                   .replaceAll('{{H5}}', getGenericHandicapDescriptionPart(betId, handicap, 5))
                   .replaceAll('{{H6}}', getGenericHandicapDescriptionPart(betId, handicap, 6))
                   .replaceAll('{{H7}}', getGenericHandicapDescriptionPart(betId, handicap, 7))
                   .replaceAll('{{H8}}', getGenericHandicapDescriptionPart(betId, handicap, 8));
    	return desc;
    } else if ((calculateHandicapDescription) && (!uselessHandicapParsing)) {
        let handicap = bet.handicap != null? bet.handicap: 0;
    	if (bet.h != null && (!handicap || handicap == 0)) {
            handicap = bet.h;
    	}
        
        return parseHandicap(desc, handicap, tipoHandicap, bet.odds || bet.eqs, bet.dia || bet.odds?.[0]?.dia, false, bet.handicapInfo || bet.ia);
    } else {
        return desc;
    }
}
